"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanCenterAccountRegion = void 0;
exports.getScanCenterDetails = getScanCenterDetails;
const interfaces_1 = require("./interfaces");
var ScanCenterAccountRegion;
(function (ScanCenterAccountRegion) {
    ScanCenterAccountRegion["DE"] = "DE";
    ScanCenterAccountRegion["INTERNATIONAL"] = "International";
})(ScanCenterAccountRegion || (exports.ScanCenterAccountRegion = ScanCenterAccountRegion = {}));
const details = {
    [interfaces_1.ActiveScanCenterCodeEnum.ODS]: {
        accountNumber: {
            [ScanCenterAccountRegion.DE]: '63035370460106',
            [ScanCenterAccountRegion.INTERNATIONAL]: '63035370465306',
        },
        city: 'Berlin',
        pickingListSenderName: 'Caya GmbH',
        postCode: '10245',
        streetAndHouseNumber: 'Ehrenbergstr. 11-14',
    },
    [interfaces_1.ActiveScanCenterCodeEnum.SPS]: {
        accountNumber: {
            [ScanCenterAccountRegion.DE]: '63035370460102',
            [ScanCenterAccountRegion.INTERNATIONAL]: '63035370465305',
        },
        city: 'Bamberg',
        pickingListSenderName: 'Caya GmbH',
        postCode: '96052',
        streetAndHouseNumber: 'Am Börstig 5',
    },
    [interfaces_1.ActiveScanCenterCodeEnum.SRZ]: {
        accountNumber: {
            [ScanCenterAccountRegion.DE]: '63035370460104',
            [ScanCenterAccountRegion.INTERNATIONAL]: '63035370465303',
        },
        city: 'Berlin',
        pickingListSenderName: 'Caya GmbH',
        postCode: '12103',
        streetAndHouseNumber: 'Bessemerstr. 83-91',
    },
};
function getScanCenterDetails({ accountRegion, publicId, scanCenter, }) {
    const { accountNumber, city, pickingListSenderName, postCode, streetAndHouseNumber, } = details[scanCenter];
    return {
        accountNumber: accountNumber[accountRegion],
        city,
        pickingListSenderName: `${pickingListSenderName} ${publicId}`,
        postCode,
        streetAndHouseNumber,
    };
}
//# sourceMappingURL=get-scan-center-details.js.map